import React, { useState, useEffect, useContext } from 'react';
import './object.css';
import { validateSteps } from "../validateSteps";
import { LanguageContext } from "../context/LanguageContext";

const CreateObjectStep7 = ({
  formData,
  setFormData,
  onBack,
  setCurrentStep,
  draftId,
  missingFields,
  setMissingFields,
  validationActive,
  setValidationActive,

  registerSubmit,
  onValidityChange,
  setLoading
}) => {

  const { texts } = useContext(LanguageContext);

  const [subscription, setSubscription] = useState(formData.subscription_plan || "");
  const [stepStatus, setStepStatus] = useState({});
  const API_URL = process.env.REACT_APP_API_URL;

  // Step‑Titel aus Sprachdatei
  const overviewItems = texts.object.step7.overviewItems;

  // -----------------------------------------------------
  // VALIDIERUNG
  // -----------------------------------------------------
  useEffect(() => {
    const { missing, stepStatus } = validateSteps(formData);
    setMissingFields(missing);
    setStepStatus(stepStatus);
  }, [formData]);

  const allStepsComplete = Object.values(stepStatus).every(v => v === true);

  useEffect(() => {
    onValidityChange(allStepsComplete);
  }, [allStepsComplete]);

  // -----------------------------------------------------
  // Abo ändern
  // -----------------------------------------------------
  const handleSubscriptionChange = (value) => {
    setSubscription(value);
    setFormData(prev => ({ ...prev, subscription_plan: value }));
  };

  // -----------------------------------------------------
  // Absenden
  // -----------------------------------------------------
  const handleSubmit = async () => {
    if (!allStepsComplete) return;

    setLoading(true);

    try {
      const token = localStorage.getItem("authToken");

      const response = await fetch(`${API_URL}/api/glamping`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        window.location.href = "/object-list";
      } else {
        const result = await response.json();
        alert(result.error || texts.object.step7.errorUnknown);
      }
    } catch (err) {
      alert(texts.object.step7.errorGeneral);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // Submit‑Funktion registrieren
  useEffect(() => {
    registerSubmit(handleSubmit);
  }, [formData, subscription]);

  // -----------------------------------------------------
  // RENDER
  // -----------------------------------------------------
  return (
    <div className="object-form-container">
      <h2 className="object-header">{texts.object.step7.title}</h2>

      {/* Fortschrittsbalken */}
      <div className="progress-bar">
        <div
          className="progress-bar-fill"
          style={{
            width: `${(Object.values(stepStatus).filter(Boolean).length / 7) * 100}%`
          }}
        ></div>
      </div>

      <div className="object-content-scroll-area">
        <div className="form-cards">

          <form className="object-form">

            <p className="object-terms-intro">
              {texts.object.step7.intro}
            </p>

            {/* Abo Auswahl */}
            <div className="subscription-box">
              <h3>{texts.object.step7.subscriptionTitle}</h3>

              <div className="subscription-options">

                {/* FREE */}
                <label className={`subscription-option ${subscription === "free" ? "active" : ""}`}>
                  <input
                    type="radio"
                    name="subscription"
                    value="free"
                    checked={subscription === "free"}
                    onChange={() => handleSubscriptionChange("free")}
                  />
                  <div className="subscription-content">
                    <strong>{texts.object.step7.freeTitle}</strong>
                    <div className="subscription-price">{texts.object.step7.freePrice}</div>
                    <div className="subscription-description">
                      {texts.object.step7.freeDescription}
                    </div>
                  </div>
                </label>

                {/* MONTHLY */}
                <label className={`subscription-option ${subscription === "monthly" ? "active" : ""}`}>
                  <input
                    type="radio"
                    name="subscription"
                    value="monthly"
                    checked={subscription === "monthly"}
                    onChange={() => handleSubscriptionChange("monthly")}
                  />
                  <div className="subscription-content">
                    <strong>{texts.object.step7.monthlyTitle}</strong>
                    <div className="subscription-price">{texts.object.step7.monthlyPrice}</div>
                    <div className="subscription-description">
                      {texts.object.step7.monthlyDescription}
                    </div>
                  </div>
                </label>

                {/* YEARLY */}
                <label className={`subscription-option ${subscription === "yearly" ? "active" : ""}`}>
                  <input
                    type="radio"
                    name="subscription"
                    value="yearly"
                    checked={subscription === "yearly"}
                    onChange={() => handleSubscriptionChange("yearly")}
                  />
                  <div className="subscription-content">
                    <strong>{texts.object.step7.yearlyTitle}</strong>
                    <div className="subscription-price">{texts.object.step7.yearlyPrice}</div>
                    <div className="subscription-description">
                      {texts.object.step7.yearlyDescription}
                    </div>
                  </div>
                </label>

              </div>
            </div>

            {/* Step Übersicht */}
            <div className="overview-card">
              <h3 className="overview-title">{texts.object.step7.overviewTitle}</h3>

              <div className="overview-grid">
                {overviewItems.map(item => (
                  <div key={item.step} className="overview-row">

                    <div className="overview-title-cell">
                      <span
                        className={`overview-status-dot ${
                          stepStatus[item.step] ? "ok" : "missing"
                        }`}
                      ></span>
                      {item.title}
                    </div>

                    <div className="overview-action-cell">
                      {!stepStatus[item.step] && (
                        <button
                          type="button"
                          className="overview-button"
                          onClick={() => {
                            setValidationActive(true);
                            setCurrentStep(item.step);
                          }}
                        >
                          {texts.object.step7.fix}
                        </button>
                      )}
                    </div>

                  </div>
                ))}
              </div>
            </div>

          </form>

        </div>
      </div>
    </div>
  );
};

export default CreateObjectStep7;
